import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Config from "app/config";
import theme from "theme";

/**
 * Styled root component
 */
export const Root = styled(Box, {
  label: "basic-layout--root"
})(() => ({
  minHeight: "100vh",
  width: "100%",
  overflow: "auto",
  backgroundColor: Config.get().theme.backgroundColor || theme.palette.background.default,
  backgroundImage: Config.get().theme.backgroundImagePath ? `url(${Config.get().theme.backgroundImagePath})` : "none",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "75%",
  backgroundAttachment: "fixed"
}));

export default Root;